/* eslint-disable no-use-before-define */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
import {
  ANDROID_SHOP,
  APPLE_SHOP,
  BIG_FONT_SIZE,
  DARK_THEME,
  HUAWEI_SHOP,
  IMAGE_TYPE_BASE_AND_SELECT_WITH_BLACK,
  IMAGE_TYPE_MANY,
  IMAGE_TYPE_VIDEO,
  IMAGE_TYPE_VIDEO_POSTER,
  IMAGE_TYPE_ZOOM,
  IMAGE_TYPE_ZOOM_VIDEO,
  IMAGE_TYPE_ZOOM_WITH_BLACK,
  LIGHT_THEME,
  MAX_SUPPORT,
  MAX_SUPPORT_PURCAHSE,
  NORM_FONT_SIZE,
  SECRET_KEY_ADMIN,
  SECRET_KEY_CONTENT,
  SMALL_FONT_SIZE,
  SYSTEM_THEME,
  TG_SUPPORT,
  TG_SUPPORT_PURCAHSE,
  VK_SUPPORT,
  WINDOW_H,
} from '../constant/constants';
import {
  AnnotaionDto,
  ImageDto,
  LectionImageDto,
  LectionSlideDto,
  VideoUrlDto,
} from '../dto/LectionImageDto';
import { MarginZoomImageDto } from '../dto/MarginZoomImageDto';
import { Image2Dto } from '../dto/WorkspaceDto';
import { AlertSeverityEnum } from '../enum/AlertSeverityEnum';
import { IAlertProps } from '../interface/IAlertProps';
import { IApiResult } from '../interface/IApiResult';
import classes from '../component/lection/LictionDiv.module.css';
import { TableDto } from '../dto/TableDto';
import { PlayerDto } from '../dto/PlayerDto';
import { PlayerSetupDto } from '../dto/PlayerSetupDto';
import { CloudDto } from '../dto/CloudDto';
import { StatDto } from '../dto/StatDto';
import { FilterStats2Dto, FilterStatsDto } from '../dto/FilterStatsDto';
import { BitsItemDto } from '../dto/BitsItemDto';
import { ImageBase6444Dto } from '../dto/ImageBase6444Dto';
import { PlayerKinescopeDto } from '../dto/PlayerKinescopeDto';
import { PlayerGeneralAllDto } from '../dto/PlayerGeneralAllDto';

export const DeviceAndroid = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;

  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const russianZones = [
      // Европейская часть и Урал
      'Europe/Kaliningrad',
      'Europe/Moscow',
      'Europe/Astrakhan',
      'Europe/Kirov',
      'Europe/Samara',
      'Europe/Saratov',
      'Europe/Ulyanovsk',
      'Europe/Volgograd',
      'Asia/Yekaterinburg',
      // Сибирь
      'Asia/Omsk',
      'Asia/Novosibirsk',
      'Asia/Barnaul',
      'Asia/Tomsk',
      'Asia/Novokuznetsk',
      'Asia/Krasnoyarsk',
      'Asia/Irkutsk',
      'Asia/Chita',
      // Дальний Восток
      'Asia/Yakutsk',
      'Asia/Vladivostok',
      'Asia/Sakhalin',
      'Asia/Magadan',
      'Asia/Srednekolymsk',
      'Asia/Ust-Nera',
      'Asia/Khandyga',
      'Asia/Kamchatka',
      'Asia/Anadyr',
    ];

    if (russianZones.includes(timeZone)) {
      return false;
    }
  } catch (error) {
    // В случае ошибки лучше пропустить проверку, чтобы не блокировать пользователей
  }

  const isDesktop = /Windows|Macintosh/i.test(ua);
  if (isDesktop) return false;

  const isIOS = /iPad|iPhone|iPod/i.test(ua);
  if (isIOS) return false;

  /*
  const lang = navigator.language || navigator.languages?.[0] || '';
  const isRussia = /^ru/i.test(lang) || /^ru-/i.test(lang);
  if (isRussia) return false;
  */

  const isAndroid = /Android/i.test(ua);
  const isHuawei = /Huawei|HUAWEI/i.test(ua);
  const isHarmonyOS = /HarmonyOS/i.test(ua);
  return isAndroid || isHuawei || isHarmonyOS;
};

export const timeSeconds = (timestr: string) => {
  const arrTimme = timestr.split(':').map(Number);
  if (arrTimme.length === 2) {
    return arrTimme[0] * 60 + arrTimme[1];
  }
  if (arrTimme.length === 1) {
    return arrTimme[0];
  }
  return arrTimme[0] * 3600 + arrTimme[1] * 60 + arrTimme[2];
};

export const formatTextToHtml = (text: string): string => {
  if (!text) return '';

  return text.replace(
    /`([^`]+)`/g,
    '<span style="color:#00C7D3;background-color:#00C7D333;font-weight:700;padding:2px 4px;border-radius:4px;font-family:monospace;">$1</span>'
  );
};

const convertMarkdownToHtml = (text: string): string => {
  let result = text;
  // Жирный текст: **текст** или __текст__
  result = result.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
  result = result.replace(/__(.*?)__/g, '<b>$1</b>');

  // Курсив: *текст* или _текст_
  result = result.replace(/\*(.*?)\*/g, '<i>$1</i>');
  result = result.replace(/_(.*?)_/g, '<i>$1</i>');

  return result;
};

// Функция преобразования Markdown-таблицы в HTML
const convertMarkdownTableToHtml = (text: string): string => {
  const lines = text.split('\n');
  let inTable = false;
  let tableRows: string[] = [];
  const result: string[] = [];

  for (const line of lines) {
    // Проверяем, является ли строка частью таблицы (начинается с | и заканчивается |)
    const isTableLine =
      line.trim().startsWith('|') && line.trim().endsWith('|');

    if (isTableLine) {
      if (!inTable) {
        inTable = true;
        tableRows = [];
      }
      tableRows.push(line.trim());
    } else {
      if (inTable) {
        // Завершаем таблицу — преобразуем накопленные строки
        result.push(convertTableRowsToHtml(tableRows));
        inTable = false;
        tableRows = [];
      }
      result.push(line);
    }
  }

  // Если таблица в конце файла
  if (inTable && tableRows.length > 0) {
    result.push(convertTableRowsToHtml(tableRows));
  }

  return result.join('\n');
};

// Преобразование строк таблицы в HTML
const convertTableRowsToHtml = (rows: string[]): string => {
  if (rows.length === 0) return '';

  let html =
    '<table border="1" style="border-collapse: collapse; margin-top: 10px; width: 100%;">\n';

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < rows.length; i++) {
    const cells = rows[i]
      .split('|')
      .filter((cell) => cell.trim() !== '')
      .map((cell) => cell.trim());

    // Пропускаем строку-разделитель (|---|---|)
    if (rows[i].includes('---') && rows[i].includes('|')) {
      // eslint-disable-next-line no-continue
      continue;
    }

    const tag = i === 0 ? 'th' : 'td';
    html += '  <tr>\n';
    for (const cell of cells) {
      html += `    <${tag} style="border: 1px solid #ccc; padding: 8px;">${cell}</${tag}>\n`;
    }
    html += '  </tr>\n';
  }

  html += '</table>\n';
  return html;
};

const convertMarkdownListsToHtml = (markdownText: string) => {
  const lines = markdownText.split('\n');
  const result = [];
  let inList = false;
  let listType = ''; // 'ul' или 'ol'
  let listItems = [];

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    // Проверка на маркированный список (-, *, +)
    const ulMatch = line.match(/^[\s]*[-*+]\s+(.+)$/);
    // Проверка на нумерованный список (1., 2., etc)
    const olMatch = line.match(/^[\s]*(\d+)\.\s+(.+)$/);

    if (ulMatch) {
      if (!inList) {
        inList = true;
        listType = 'ul';
        listItems = [];
      }
      listItems.push(ulMatch[1]);
    } else if (olMatch) {
      if (!inList) {
        inList = true;
        listType = 'ol';
        listItems = [];
      }
      listItems.push(olMatch[2]);
    } else {
      // Если вышли из списка, закрываем его
      if (inList) {
        const listTag = listType === 'ul' ? 'ul' : 'ol';
        const itemsHtml = listItems.map((item) => `<li>${item}</li>`).join('');
        result.push(`<${listTag}>${itemsHtml}</${listTag}>`);
        inList = false;
        listItems = [];
      }
      // Добавляем обычную строку (если не пустая)
      if (line.trim() !== '') {
        result.push(line);
      } else {
        result.push('');
      }
    }
  }

  // Если список был в конце текста
  if (inList) {
    const listTag = listType === 'ul' ? 'ul' : 'ol';
    const itemsHtml = listItems.map((item) => `<li>${item}</li>`).join('');
    result.push(`<${listTag}>${itemsHtml}</${listTag}>`);
  }

  return result.join('\n');
};

export const formatConspect = (text: string, idMy: string) => {
  const arrayFormat: PlayerGeneralAllDto = {
    title: '',
    conspectPlayer: [],
  };

  const arrall = text.split('\n');
  let sectionStart = false;
  let textStart = false;
  let textSum = '';
  let item: PlayerKinescopeDto = {
    duration: 0,
    hintDuration: '',
    html: '',
    id: '',
    poster: '',
    promegutok: '',
    seek: 0,
    text: '',
    title: '',
  };

  for (let i = 0; i < arrall.length; i += 1) {
    if (i === 0) {
      arrayFormat.title = arrall[i].replaceAll('# ', '');
    }
    if (arrall[i].includes('<section')) {
      sectionStart = true;
    }
    if (arrall[i].includes('</section>')) {
      // Сначала преобразуем списки Markdown в HTML
      let convertedText = convertMarkdownListsToHtml(textSum);
      // Затем преобразуем остальной Markdown
      convertedText = convertMarkdownToHtml(convertedText);
      convertedText = convertMarkdownTableToHtml(convertedText);

      item.id = `${idMy}_${i}`;
      item.text = convertedText;
      arrayFormat.conspectPlayer.push(item);
      sectionStart = false;
      textStart = false;
      textSum = '';
      item = {
        duration: 0,
        hintDuration: '',
        html: '',
        id: '',
        poster: '',
        promegutok: '',
        seek: 0,
        text: '',
        title: '',
      };
    }
    if (sectionStart) {
      if (arrall[i].includes('<button')) {
        const arrPromegurok = arrall[i].split('**');
        const arrPromegurok11 = arrPromegurok[1].split('-');
        const sseek = timeSeconds(arrPromegurok11[0]);
        const ddura = timeSeconds(arrPromegurok11[1]) - sseek;
        item.promegutok = arrPromegurok[1];
        item.seek = sseek;
        item.duration = ddura;
      }
      if (textStart) {
        // Добавляем строку, но не добавляем лишние <br/> для пустых строк
        if (arrall[i].trim() !== '') {
          textSum += `${arrall[i]}\n`;
        } else {
          textSum += '\n';
        }
      }
      if (arrall[i].includes('###')) {
        const title = arrall[i].replaceAll('### ', '');
        item.title = title;
        textStart = true;
      }
    }
  }
  return arrayFormat;
};

export const formatConspect2 = (text: string, idMy: string) => {
  const arrayFormat: PlayerGeneralAllDto = {
    title: '',
    conspectPlayer: [],
  };
  const arrall = text.split('\n');
  let sectionStart = false;
  let textStart = false;
  let textSum = '';
  let item: PlayerKinescopeDto = {
    duration: 0,
    hintDuration: '',
    html: '',
    id: '',
    poster: '',
    promegutok: '',
    seek: 0,
    text: '',
    title: '',
  };
  for (let i = 0; i < arrall.length; i += 1) {
    if (i === 0) {
      arrayFormat.title = arrall[i].replaceAll('# ', '');
    }
    if (arrall[i].includes('<section')) {
      sectionStart = true;
    }
    if (arrall[i].includes('</section>')) {
      item.id = `${idMy}_${i}`;
      item.text = textSum;
      arrayFormat.conspectPlayer.push(item);
      sectionStart = false;
      textStart = false;
      textSum = '';
      item = {
        duration: 0,
        hintDuration: '',
        html: '',
        id: '',
        poster: '',
        promegutok: '',
        seek: 0,
        text: '',
        title: '',
      };
    }
    if (sectionStart) {
      if (arrall[i].includes('<button')) {
        const arrPromegurok = arrall[i].split('**');
        const arrPromegurok11 = arrPromegurok[1].split('-');
        const sseek = timeSeconds(arrPromegurok11[0]);
        const ddura = timeSeconds(arrPromegurok11[1]) - sseek;
        item.promegutok = arrPromegurok[1];
        item.seek = sseek;
        item.duration = ddura;
      }
      if (textStart) {
        textSum += `${arrall[i]}<br/>`;
      }
      if (arrall[i].includes('###')) {
        const title = arrall[i].replaceAll('### ', '');
        item.title = title;
        textStart = true;
      }
    }
  }
  return arrayFormat;
};

export function timeToSeconds(timeStr: string): number {
  const parts = timeStr.split(':').map(Number);

  if (parts.length === 3) {
    // HH:MM:SS
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  }
  if (parts.length === 2) {
    // MM:SS
    return parts[0] * 60 + parts[1];
  }
  return 0;
}

export function parseLectureBlocks(
  html: string,
  baseId: string
): PlayerKinescopeDto[] {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const sections = doc.querySelectorAll('section.lecture-block');

  const result: PlayerKinescopeDto[] = [];

  sections.forEach((section, index) => {
    // Извлекаем временные метки
    const startAttr = section.getAttribute('data-start');
    const endAttr = section.getAttribute('data-end');

    if (!startAttr || !endAttr) return;

    // Парсим время в секунды
    const seek = timeToSeconds(startAttr);
    const endTime = timeToSeconds(endAttr);
    const duration = endTime - seek;

    // Извлекаем заголовок (первый заголовок внутри секции)
    const titleElement = section.querySelector('h1, h2, h3, h4');
    let title = titleElement?.textContent?.trim() || `Эпизод ${index + 1}`;

    // Очищаем заголовок от эмодзи и лишнего
    title = title.replace(/^###\s*/, '').trim();

    // Извлекаем текст содержимого
    // Копируем содержимое и удаляем временные метки и кнопки
    const contentClone = section.cloneNode(true) as HTMLElement;

    // Удаляем элементы с временными метками и кнопками
    const elementsToRemove = contentClone.querySelectorAll(
      'button, [data-start]'
    );
    elementsToRemove.forEach((el) => el.remove());

    // Также удаляем заголовок из текста (чтобы не дублировать)
    const clonedTitle = contentClone.querySelector('h1, h2, h3, h4');
    if (clonedTitle) clonedTitle.remove();

    let text = contentClone.textContent?.trim() || '';

    // Приводим текст в порядок (убираем лишние пробелы и переносы)
    text = text.replace(/\s+/g, ' ').trim();

    // Генерируем id
    const id = `${baseId}_epizode${index + 1}`;

    result.push({
      id,
      title,
      seek,
      duration: Math.round(duration),
      text,
      poster: '',
    });
  });

  return result;
}

export const formatDurationVideoLection = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const formatTimeRange = (seek: number, duration: number): string => {
  const formatTime = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    // Всегда показываем часы, даже если 0
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const endTime = seek + duration;

  return `${formatTime(seek)} - ${formatTime(endTime)}`;
};

export const formatTimeStart = (seek: number): string => {
  const formatTime = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    // Всегда показываем часы, даже если 0
    return `${minutes.toString().padStart(2, '0')}:${secs
      .toString()
      .padStart(2, '0')}`;
  };

  return `${formatTime(seek)}`;
};

export const GetKineskopeUrlWithParams = (
  url: string,
  playerSetup?: PlayerKinescopeDto
) => {
  if (playerSetup === undefined) {
    return url;
  }
  if (playerSetup.seek !== undefined && playerSetup.duration !== undefined) {
    // return `${url}?seek=${playerSetup.seek}&duration=${playerSetup.duration}&t=0`;
    return `${url}?t=${playerSetup.seek}`;
  }
  return url;
};

export const HandleVkSupport = (isPurchase: string) => {
  if (isPurchase !== '') {
    window.open(VK_SUPPORT);
  } else {
    window.open(VK_SUPPORT);
  }
};

export const HandleTelegramSupport = (isPurchase: string) => {
  if (isPurchase !== '') {
    window.open(`${TG_SUPPORT_PURCAHSE}${isPurchase}`);
  } else {
    window.open(TG_SUPPORT);
  }
};

export const HandleMaxSupport = (isPurchase: string) => {
  if (isPurchase !== '') {
    window.open(`${MAX_SUPPORT_PURCAHSE}${isPurchase}`);
  } else {
    window.open(MAX_SUPPORT);
  }
};

export const HandleAutoShopView = (device: number) => {
  if (device === 0) {
    window.open(APPLE_SHOP);
  }
  if (device === 1) {
    window.open(ANDROID_SHOP);
  }
  if (device === 2) {
    window.open(HUAWEI_SHOP);
  }
};

export const generateUserIdMemmorySng = () =>
  `auto_sng_${Math.random().toString(36).substr(2, 9)}${Date.now().toString(
    36
  )}`;

export const generateUserIdMemmory = () =>
  `auto_${Math.random().toString(36).substr(2, 9)}${Date.now().toString(36)}`;

// Генерация уникального ID
export const generateUserId = () =>
  `shop_${Math.random().toString(36).substr(2, 9)}${Date.now().toString(36)}`;

export const getOrCreateUserId = () => {
  let userId = localStorage.getItem('anonymousUserId');
  if (!userId) {
    userId = generateUserId();
    localStorage.setItem('anonymousUserId', userId);
  }
  return userId;
};

export const GetFon = (type: number) => {
  let fonnnewwww = '#000000';
  if (
    type === IMAGE_TYPE_ZOOM_VIDEO ||
    type === IMAGE_TYPE_VIDEO ||
    type === IMAGE_TYPE_VIDEO_POSTER
  ) {
    fonnnewwww = '#1a1a1a';
  }
  return fonnnewwww;
};

export const GetFon2 = (type: number) => {
  let fonnnewwww = '#EFF3F4';
  if (
    type === IMAGE_TYPE_ZOOM_VIDEO ||
    type === IMAGE_TYPE_VIDEO ||
    type === IMAGE_TYPE_VIDEO_POSTER
  ) {
    fonnnewwww = '#f5f5f5';
  }
  return fonnnewwww;
};

export const GetVideoUrlToTheme = (
  id: string,
  theme: number,
  dtos: VideoUrlDto[]
) => {
  let ur = id;
  for (let i = 0; i < dtos.length; i += 1) {
    if (dtos[i].id === id) {
      if (theme === LIGHT_THEME) {
        ur = dtos[i].light ?? '';
      } else {
        ur = dtos[i].dark ?? '';
      }
    }
  }
  return ur;
};

export const GetPosterName = (
  id: string,
  theme: number,
  dtos: VideoUrlDto[]
) => {
  let ur = '';
  for (let i = 0; i < dtos.length; i += 1) {
    if (dtos[i].id === id) {
      if (theme === LIGHT_THEME) {
        ur = dtos[i].nameLight;
      } else {
        ur = dtos[i].nameDark;
      }
    }
  }
  if (ur !== '') {
    ur = `${ur.split('.')[0]}_poster.webp`;
  }
  return ur;
};

export const GetLightOrDarkVideoName = (
  id: string,
  curTheme: number,
  dtos: VideoUrlDto[]
) => {
  let ur = '';
  for (let i = 0; i < dtos.length; i += 1) {
    if (dtos[i].id === id) {
      if (curTheme === LIGHT_THEME) {
        ur = dtos[i].nameLight;
      } else {
        ur = dtos[i].nameDark;
      }
    }
  }
  return ur;
};

export const GetDarkVideoName = (id: string, dtos?: VideoUrlDto[]) => {
  let ur = '';
  if (dtos !== undefined) {
    for (let i = 0; i < dtos.length; i += 1) {
      if (dtos[i].id === id) {
        ur = dtos[i].nameDark;
      }
    }
  }

  return ur;
};

export const HasVideoUrlToTheme = (id: string, dtos: VideoUrlDto[]) => {
  let ur = false;
  for (let i = 0; i < dtos.length; i += 1) {
    if (dtos[i].id === id) {
      ur = true;
    }
  }
  return ur;
};

export const HandleView = (url: string) => {
  window.open(url);
};

export const formatSlideToPosition = (
  slide: number,
  image: number,
  fullText: number
) => {
  let slideText = slide.toString();
  if (slideText.length === 1) {
    slideText = `00${slideText}`;
  }
  if (slideText.length === 2) {
    slideText = `0${slideText}`;
  }

  let imageText = image.toString();
  if (imageText.length === 1) {
    imageText = `00${imageText}`;
  }
  if (imageText.length === 2) {
    imageText = `0${imageText}`;
  }
  return parseInt(`${slideText}${imageText}`, 10);
};

export const findBase64Image = (
  image: string,
  imageArray?: ImageBase6444Dto[]
) => {
  let base6444 = '';
  if (imageArray !== undefined) {
    for (let i = 0; i < imageArray.length; i += 1) {
      if (imageArray[i].name === image) {
        base6444 = imageArray[i].base64Image;
      }
    }
  }
  return base6444;
};

export const formatPositionToSlide = (position: number) => {
  let slide = 0;
  let image = 0;
  const arrPos = [];

  if (position === 0) {
    slide = 0;
    image = 0;
  }
  if (position < 1000) {
    slide = 0;
    image = position;
  }
  if (position >= 1000) {
    let slideText = position.toString();
    if (slideText.length === 4) {
      slideText = `00${slideText}`;
    }
    if (slideText.length === 5) {
      slideText = `0${slideText}`;
    }
    slide = parseInt(slideText.substring(0, 3), 10);
    image = parseInt(slideText.substring(3), 10);
  }

  arrPos[0] = slide;
  arrPos[1] = image;
  return arrPos;
};

export const viewOneSlideToAllSide = (dtos: LectionSlideDto[]) => {
  const item: LectionSlideDto = {
    id: '',
    annotations: [],
    videoUrl: [],
    videoMetadata: [],
    selectBackgroundColor: '',
    buttonColor: '',
    audio: '',
    selectTextColor: '',
    slideImages: [],
    text: '',
    tableContent: '',
    backgroundDiv: '',
    backgroundImage: '',
    backgroundText: '',
    buttonColor2: '',
    textColor: '',
    isAndroid: '',
    progressColor: '',
  };
  const allSlide: LectionSlideDto[] = [];
  let text = '';
  const slideImages: LectionImageDto[] = [];
  const annotations: AnnotaionDto[] = [];
  const videoUrl: VideoUrlDto[] = [];
  for (let i = 0; i < dtos.length; i += 1) {
    item.selectBackgroundColor = dtos[0].selectBackgroundColor;
    item.buttonColor = dtos[0].buttonColor;
    item.selectTextColor = dtos[0].selectTextColor;
    item.backgroundImage = dtos[0].backgroundImage;
    item.backgroundDiv = dtos[0].backgroundDiv;
    item.backgroundText = dtos[0].backgroundText;
    item.buttonColor2 = dtos[0].buttonColor2;
    item.textColor = dtos[0].textColor;
    item.progressColor = dtos[0].progressColor;
    item.id = dtos[i].id;
    if (i === dtos.length - 1) {
      text = `${text} ${dtos[i].text}<div id="divider_${i}""> </div>`;
    } else {
      text = `${text} ${dtos[i].text}<div id="divider_${i}""> </div><div style=" border-top: 1px solid #e0e0e0; margin-top: 10px; margin-bottom: 10px"> </div>`;
    }

    for (let j = 0; j < dtos[i].slideImages.length; j += 1) {
      slideImages.push(dtos[i].slideImages[j]);
    }
    for (let j = 0; j < dtos[i].annotations.length; j += 1) {
      annotations.push(dtos[i].annotations[j]);
    }
    for (let j = 0; j < dtos[i].videoUrl.length; j += 1) {
      videoUrl.push(dtos[i].videoUrl[j]);
    }
  }
  item.text = text;
  item.slideImages = slideImages;
  item.annotations = annotations;
  item.videoUrl = videoUrl;

  allSlide.push(item);
  return allSlide;
};

export const getColorPredmet = (
  predmet: number,
  buyTypes: number,
  purchaseId: string
) => {
  if (buyTypes === 0) {
    return '#bdbdbd';
  }
  if (buyTypes === -1) {
    return '#795548';
  }
  if (predmet === 0) {
    if (purchaseId.includes('year')) {
      return '#f06292';
    }
    return '#c2185b';
  }
  if (predmet === 1) {
    if (purchaseId.includes('year')) {
      return '#7b1fa2';
    }
    return '#ba68c8';
  }
  if (predmet === 2) {
    if (purchaseId.includes('year')) {
      return '#1976d2';
    }
    return '#64b5f6';
  }
  if (predmet === 3) {
    if (purchaseId.includes('year')) {
      return '#00796b';
    }
    return '#4db6ac';
  }
  if (predmet === 4) {
    if (purchaseId.includes('year')) {
      return '#f57c00';
    }
    return '#ffb74d';
  }
  if (predmet === 5) {
    if (purchaseId.includes('year')) {
      return '#e64a19';
    }
    return '#ff8a65';
  }
  return '#9e9e9e';
};

export const getSum = (purchaseId: string, datetime: string) => {
  let sum = -1;
  const date1 = datetime;
  const date2 = '2025-08-01 00:00:00';
  const isDate1Less = datetime < date2;
  if (isDate1Less) {
    if (purchaseId.includes('com.learnanat.2d.fullaccess')) {
      sum = 390;
      if (purchaseId.includes('year')) {
        sum = 2340;
      }
    }
    if (purchaseId.includes('com.learnanat.fullaccess')) {
      sum = 490;
      if (purchaseId.includes('year')) {
        sum = 2940;
      }
    }
    if (purchaseId.includes('com.learnmed.histology.fullaccess')) {
      sum = 349;
      if (purchaseId.includes('year')) {
        sum = 2090;
      }
    }
    if (purchaseId.includes('com.learnmed.physiology.fullaccess')) {
      sum = 349;
      if (purchaseId.includes('year')) {
        sum = 2090;
      }
    }
    if (purchaseId.includes('com.learnmed.biochemistry.fullaccess')) {
      sum = 349;
      if (purchaseId.includes('year')) {
        sum = 2090;
      }
    }
    if (purchaseId.includes('com.learnmed.fullaccess')) {
      sum = 1090;
      if (purchaseId.includes('year')) {
        sum = 6490;
      }
    }
  } else {
    if (purchaseId.includes('com.learnanat.2d.fullaccess')) {
      sum = 390;
      if (purchaseId.includes('year')) {
        sum = 2340;
      }
    }
    if (purchaseId.includes('com.learnanat.fullaccess')) {
      sum = 540;
      if (purchaseId.includes('year')) {
        sum = 3240;
      }
    }
    if (purchaseId.includes('com.learnmed.histology.fullaccess')) {
      sum = 360;
      if (purchaseId.includes('year')) {
        sum = 2160;
      }
    }
    if (purchaseId.includes('com.learnmed.physiology.fullaccess')) {
      sum = 360;
      if (purchaseId.includes('year')) {
        sum = 2160;
      }
    }
    if (purchaseId.includes('com.learnmed.biochemistry.fullaccess')) {
      sum = 360;
      if (purchaseId.includes('year')) {
        sum = 2160;
      }
    }
    if (purchaseId.includes('com.learnmed.fullaccess')) {
      sum = 810;
      if (purchaseId.includes('year')) {
        sum = 4860;
      }
    }
  }

  return sum;
};

export const formatBits = (
  bitsInout: string,
  from: string,
  to: string,
  predmet: number
) => {
  const arrayNew: BitsItemDto[] = [];
  const arrBits = bitsInout.split('**');

  let yearsFrom = parseInt(from.split('-')[0], 10);
  let monthsFrom = parseInt(from.split('-')[1], 10);
  let textMonth = `${yearsFrom}${monthsFrom}`;

  const yearsTo = parseInt(to.split('-')[0], 10);
  const monthsTo = parseInt(to.split('-')[1], 10);

  const limit = (yearsTo - yearsFrom) * 12 + (monthsTo - monthsFrom) + 1;

  let arrayNew2: BitsItemDto[] = [];
  for (let i = 0; i < limit; i += 1) {
    if (monthsFrom < 10) {
      textMonth = `${yearsFrom}0${monthsFrom}`;
    } else {
      textMonth = `${yearsFrom}${monthsFrom}`;
    }
    const itenMew: BitsItemDto = {
      background: getColorPredmet(predmet, 0, ''),
      buyType: 0,
      cnt: 1,
      datetime: '',
      month: textMonth,
      predmet,
    };
    monthsFrom += 1;
    if (monthsFrom > 12) {
      monthsFrom = 1;
      yearsFrom += 1;
    }
    arrayNew2.push(itenMew);
  }

  for (let i = 0; i < arrBits.length; i += 1) {
    const item = arrBits[i].split(';');
    if (item.length === 3) {
      const purchaseId = item[0];
      const datetime = item[1];
      const result = item[2];

      let predmetType = -1;
      if (purchaseId.includes('com.learnanat.2d.fullaccess')) {
        predmetType = 0;
      }
      if (purchaseId.includes('com.learnanat.fullaccess')) {
        predmetType = 1;
      }
      if (purchaseId.includes('com.learnmed.histology.fullaccess')) {
        predmetType = 2;
      }
      if (purchaseId.includes('com.learnmed.physiology.fullaccess')) {
        predmetType = 3;
      }
      if (purchaseId.includes('com.learnmed.biochemistry.fullaccess')) {
        predmetType = 4;
      }
      if (purchaseId.includes('com.learnmed.fullaccess')) {
        predmetType = 5;
      }
      let buyTypes = 1;
      if (result.includes('refund')) {
        buyTypes = -1;
      }

      let cnts = 1;
      if (purchaseId.includes('year')) {
        cnts = 12;
      }

      const datetimes = datetime.split(' ')[0];
      const years = datetimes.split('-')[0];
      const months = datetimes.split('-')[1];
      const textMonths = `${years}${months}`;
      const itenMew: BitsItemDto = {
        background: getColorPredmet(predmetType, buyTypes, purchaseId),
        buyType: buyTypes,
        cnt: cnts,
        datetime: datetimes,
        month: textMonths,
        predmet: predmetType,
      };
      if (predmetType === predmet) {
        arrayNew2 = arrayNew2.filter((item2) => item2.month !== textMonths);
        arrayNew2.push(itenMew);
        arrayNew.push(itenMew);
      }
    }
  }
  arrayNew2 = arrayNew2.sort((a, b) => {
    if (a.month.toLowerCase() < b.month.toLowerCase()) return -1;
    if (a.month.toLowerCase() > b.month.toLowerCase()) return 1;
    return 0;
  });
  if (arrayNew.length === 0) {
    arrayNew2 = [];
  }
  return arrayNew2;
};

export const formatSum = (sum: number) => {
  const sSum = `${sum}`;
  let newSumm = '';
  let cnt = 0;
  for (let i = 0; i < sSum.length; i += 1) {
    newSumm = `${sSum[sSum.length - 1 - i]}${newSumm}`;
    cnt += 1;
    if (cnt === 3) {
      cnt = 0;
      newSumm = ` ${newSumm}`;
    }
  }
  return newSumm;
};

export const filterDateStats = async (
  statsDto: StatDto[],
  filter2Dto: FilterStats2Dto
) => {
  const arrayso: StatDto[] = [];
  for (let i = 0; i < statsDto.length; i += 1) {
    if (
      statsDto[i].result !== '' &&
      statsDto[i].result !== 'payment.canceled' &&
      statsDto[i].datetime >= filter2Dto.from &&
      statsDto[i].datetime <= filter2Dto.to
    ) {
      if (
        statsDto[i].result === 'payment.succeeded' ||
        statsDto[i].result === 'refund.succeeded'
      ) {
        arrayso.push(statsDto[i]);
      }
    }
  }

  return arrayso;
};

export const filterStats = async (
  statsDto: StatDto[],
  filterDto: FilterStatsDto
) => {
  let sumSun = 0;
  let sumCnt = 0;
  const arrayso: StatDto[] = [];
  const idKassa: string[] = [];

  for (let i = 0; i < statsDto.length; i += 1) {
    if (
      statsDto[i].result !== '' &&
      statsDto[i].result !== 'payment.canceled'
    ) {
      if (
        (filterDto.isAn2D === 1 &&
          statsDto[i].purchaseId.includes('com.learnanat.2d.fullaccess')) ||
        (filterDto.isAn3D === 1 &&
          statsDto[i].purchaseId.includes('com.learnanat.fullaccess')) ||
        (filterDto.isHist === 1 &&
          statsDto[i].purchaseId.includes(
            'com.learnmed.histology.fullaccess'
          )) ||
        (filterDto.isPhys === 1 &&
          statsDto[i].purchaseId.includes(
            'com.learnmed.physiology.fullaccess'
          )) ||
        (filterDto.isBioh === 1 &&
          statsDto[i].purchaseId.includes(
            'com.learnmed.biochemistry.fullaccess'
          )) ||
        (filterDto.isAll === 1 &&
          statsDto[i].purchaseId.includes('com.learnmed.fullaccess'))
      ) {
        if (
          (filterDto.isMonth === 1 &&
            !statsDto[i].purchaseId.includes('.year')) ||
          (filterDto.isYear === 1 && statsDto[i].purchaseId.includes('.year'))
        ) {
          arrayso.push(statsDto[i]);
        }
      }
    }
  }

  const arrayso2: StatDto[] = arrayso.sort((a, b) => {
    if (a.user.toLowerCase() < b.user.toLowerCase()) return -1;
    if (a.user.toLowerCase() > b.user.toLowerCase()) return 1;
    return 0;
  });

  const arrayso11: StatDto[] = [];
  let cnt = 0;
  let summa = 0;
  let bits = '';
  let phoneType = '';
  for (let i = 0; i < arrayso2.length; i += 1) {
    let isAdd = 0;
    if (arrayso2[i].result === 'payment.succeeded') {
      cnt += 1;
      summa += getSum(arrayso2[i].purchaseId, arrayso2[i].datetime);
    }
    if (arrayso2[i].result === 'refund.succeeded') {
      idKassa.push(arrayso2[i].idKassa);
      cnt -= 1;
      summa -= getSum(arrayso2[i].purchaseId, arrayso2[i].datetime);
    }

    phoneType = 'Android';
    if (arrayso2[i].user.includes('.')) {
      phoneType = 'Iphone';
    }
    if (arrayso2[i].user.includes('Huawei')) {
      phoneType = 'Huawei';
    }
    bits = `${bits}${arrayso2[i].purchaseId};${arrayso2[i].datetime};${arrayso2[i].result}**`;
    if (i === arrayso2.length - 1) {
      isAdd = 1;
    }
    if (i !== arrayso2.length - 1) {
      if (arrayso2[i].user !== arrayso2[i + 1].user) {
        isAdd = 1;
      }
    }
    if (isAdd === 1) {
      isAdd = 0;
      arrayso2[i].cnt = cnt;
      arrayso2[i].bits = bits;
      arrayso2[i].phoneType = phoneType;
      arrayso2[i].paySum = summa;
      if (
        (filterDto.isHuaw === 1 && phoneType === 'Huawei') ||
        (filterDto.isAndr === 1 && phoneType === 'Android') ||
        (filterDto.isIpho === 1 && phoneType === 'Iphone')
      ) {
        sumSun += summa;
        sumCnt += cnt;
        arrayso11.push(arrayso2[i]);
      }
      summa = 0;
      cnt = 0;
      bits = '';
      phoneType = '';
    }
  }

  let newArray: StatDto[] = arrayso11;
  for (let i = 0; i < idKassa.length; i += 1) {
    newArray = newArray.filter((item) => item.idKassa !== idKassa[i]);
  }
  const arrayAll: any[] = [];
  arrayAll[0] = newArray;
  arrayAll[1] = sumSun;
  arrayAll[2] = sumCnt;
  return arrayAll;
};

export const changeFormatDateWithDiff = (
  inputValue?: string,
  type?: string
) => {
  let result = '';
  if (inputValue) {
    const arrayDate = inputValue.split('.');
    if (arrayDate.length === 3) {
      if (type === undefined) {
        result = `${arrayDate[2]}-${arrayDate[1]}-${arrayDate[0]}`;
      } else {
        if (type === 'date') {
          result = `${arrayDate[2]}-${arrayDate[1]}-${arrayDate[0]}`;
        }
        if (type === 'month') {
          result = `${arrayDate[2]}-${arrayDate[1]}`;
        }
        if (type === 'number') {
          result = `${arrayDate[2]}`;
        }
      }
    } else {
      result = inputValue;
    }
  }
  return result;
};

export const getDefaultDateToReport = (day: number, type?: string) => {
  const nowDate = new Date().getTime();
  const nowFormatDate = new Date(nowDate - day * 24 * 60 * 60 * 1000);
  const result = nowFormatDate.toLocaleDateString();
  return changeFormatDateWithDiff(result, type);
};

export const getClassName = (
  is5rows: boolean,
  is4rows: boolean,
  is3rows: boolean,
  windowType: number
) => {
  if (windowType === WINDOW_H) {
    return classes.container2rows;
  }
  if (is3rows) {
    return classes.container3rows;
  }
  if (is4rows) {
    return classes.container4rows;
  }
  if (is5rows) {
    return classes.container5rows;
  }
  return classes.container5rows;
};

export const getClassName2 = (
  cnt: number,
  isEmpty: boolean,
  isTable: boolean
) => {
  if (isTable) {
    return classes.container1Columns2;
  }
  if (cnt > 0 && !isEmpty) {
    return classes.container2Columns;
  }
  return classes.container1Columns;
};

export const getHeightMegduSlov = (textSize: string) => {
  if (textSize === SMALL_FONT_SIZE) {
    return '14px';
  }
  if (textSize === NORM_FONT_SIZE) {
    return '22px';
  }
  if (textSize === BIG_FONT_SIZE) {
    return '28px';
  }
  return '22px';
};

export const getPageNumId = (allname: string) => {
  const name = allname.replaceAll('page_', '');
  return name;
};

export const getPlayerList = (dto: PlayerSetupDto) => {
  const listArr = dto.idOther.split(';;;');
  const nameArr = dto.videoName.split(';;;');
  const arrPlayer: PlayerDto[] = [];
  for (let i = 0; i < listArr.length; i += 1) {
    const itemDto: PlayerDto = {
      id: listArr[i],
      title: nameArr[i],
      link: `https://kinescope.io/embed/${listArr[i]}`,
    };
    arrPlayer.push(itemDto);
  }
  return arrPlayer;
};

export const formatTestToHtml = (test: string) => {
  let testFormat = '';
  const testArr = test.split('</br>');
  let questionCnt = 1;
  for (let i = 0; i < testArr.length; i += 1) {
    const item1 = testArr[i].split('.');
    if (testArr[i] !== '') {
      try {
        const numAnswer = parseInt(item1[0], 10);
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(numAnswer)) {
          testArr[i] = `<b>ВОПРОС ${questionCnt}.</b> ${testArr[i]}`;
          questionCnt += 1;
        } else {
          testArr[i] = `<i>Ответ.</i> ${item1[1]}`;
        }
      } catch {
        testArr[i] = `ВОПРОС ${questionCnt}. ${testArr[i]}`;
        questionCnt += 1;
      }
    }
    if (testArr[i].includes('+')) {
      testArr[i] = testArr[i].replaceAll('+', '');
      testArr[i] = `<font style="color:green;">${testArr[i]}</font>`;
    }

    testFormat = `${testFormat} ${testArr[i]} </br>`;
  }
  return testFormat;
};

export const findPlayerList = (
  playerList: PlayerDto[],
  playerItem: PlayerSetupDto,
  getLast: boolean
) => {
  let itemDto: PlayerDto = {
    id: '',
    title: '',
    link: '',
  };
  for (let i = 0; i < playerList.length; i += 1) {
    if (playerList[i].id === playerItem.id || getLast) {
      itemDto = playerList[i];
    }
  }
  return itemDto;
};

export const findNextPlayerList = (playerList: PlayerDto[], id: string) => {
  let itemDto: PlayerDto = {
    id: '',
    title: '',
    link: '',
  };
  let isNext = 0;
  for (let i = 0; i < playerList.length; i += 1) {
    if (isNext === 1) {
      itemDto = playerList[i];
    }
    if (playerList[i].id === id) {
      isNext = 1;
    }
  }
  return itemDto;
};

export const getTable = (tableContent: string) => {
  const arrTable = tableContent.split('#**#');

  const arrRows: string[][] = [];

  for (let i = 1; i < arrTable.length; i += 1) {
    const item: string[] = arrTable[i].split('**');
    arrRows.push(item);
  }

  const tableDto: TableDto = {
    headers: arrTable[0].split('**'),
    rows: arrRows,
  };

  return tableDto;
};

export const selectTheme = (
  colors: string,
  select: number,
  realSystem: number
) => {
  let value = colors;
  const arrColor = value.split(';');
  if (arrColor.length === 2) {
    if (select === LIGHT_THEME) {
      value = arrColor[0];
    }
    if (select === DARK_THEME) {
      value = arrColor[1];
    }
    if (select === SYSTEM_THEME) {
      value = arrColor[realSystem];
    }
  }
  return value;
};

export const formatText = (dtos: LectionSlideDto[]) => {
  const lectionDtos: LectionSlideDto[] = dtos;
  for (let i = 0; i < lectionDtos.length; i += 1) {
    lectionDtos[i].text = lectionDtos[i].text.replaceAll('#**#', '"');
    lectionDtos[i].slideImages = lectionDtos[i].slideImages.sort(
      (a, b) => a.position - b.position
    );
  }

  return lectionDtos;
};

export const findSlideAndStepFromImageId = (
  imageId: string,
  dtos: LectionSlideDto[]
) => {
  const arr = [];
  for (let i = 0; i < dtos.length; i += 1) {
    for (let j = 0; j < dtos[i].slideImages.length; j += 1) {
      if (dtos[i].slideImages[j].id === imageId) {
        arr[0] = i;
        arr[1] = j;
      }
    }
  }
  return arr;
};

export const convertTextToHtml = (text: string) => {
  let value = text;
  value = value.replaceAll('\n', '</br>');
  value = value.replaceAll('\t', '');
  value = value.replaceAll('\r', '');
  value = value.replaceAll('"', '#**#');
  return value;
};

export const convertHtmlToText = (text: string) => {
  let value = text;
  value = value.replaceAll('</br>', '\n');
  value = value.replaceAll('#**#', '"');
  return value;
};

export const findAnnotaionsFromId = (
  annotationId: string,
  dto: LectionSlideDto
) => {
  let annotation: AnnotaionDto = {
    id: '',
    title: '',
    text: '',
  };
  for (let j = 0; j < dto.annotations.length; j += 1) {
    if (dto.annotations[j].id === annotationId) {
      annotation = dto.annotations[j];
    }
  }
  return annotation;
};

export const calcProgress2 = (
  curStep: number,
  stepCnt: number,
  curSlide: number,
  slideIndex: number
) => {
  if (slideIndex < curSlide) {
    return 100;
  }
  if (slideIndex > curSlide) {
    return -1;
  }
  const prog = (curStep / (stepCnt - 1)) * 100;
  return prog;
};

export const calcProgress = (
  step: number,
  slide: number,
  dto: LectionSlideDto[]
) => {
  let stepCnt = 0;
  let stepFromOtherSlide = 0;
  for (let i = 0; i < dto.length; i += 1) {
    for (let j = 0; j < dto[i].slideImages.length; j += 1) {
      if (i < slide) {
        stepFromOtherSlide += 1;
      }
      stepCnt += 1;
    }
  }
  const prog = ((step + 1 + stepFromOtherSlide) / stepCnt) * 100;
  return prog;
};

export const fillEmptyMarginDto = (cnt: number) => {
  const result: MarginZoomImageDto[] = [];
  for (let i = 0; i < cnt; i += 1) {
    const item: MarginZoomImageDto = {
      l: 0,
      t: 0,
      r: 0,
      b: 0,
    };
    result.push(item);
  }
  return result;
};

export const getNeedValue = (
  needValue: number,
  curValue: number,
  accurance: number
) => {
  let result = curValue;
  for (let i = 0; i < 20; i += 1) {
    const diff = needValue - result;
    result += diff;
    if (diff < accurance) {
      break;
    }
  }
  return result;
};

export const isMobileView = () => {
  const result = window.innerWidth < 820;
  return result;
};

export const getInset = () => {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue('--host-nav-overlap-top')
    .trim();
  const inset = parseInt(value, 10) || 0;
  return inset;
};

export const getImgWidthVideo = () => {
  const inset = getInset();
  if (window.innerWidth > window.innerHeight - inset) {
    return window.innerWidth / 2 - 20;
  }
  if (window.innerWidth > 450) {
    return '450px';
  }
  return '100%';
};

export const getImgWidthVideoKines = () => {
  const inset = getInset();
  if (window.innerWidth > window.innerHeight - inset) {
    let widthCalc = window.innerWidth / 2;
    if (window.innerHeight - inset < widthCalc) {
      widthCalc = window.innerHeight - inset;
    }
    return widthCalc - 10;
  }
  if ((window.innerHeight - inset) / 2 < window.innerWidth) {
    return (window.innerHeight - inset) / 2 - 10;
  }
  return window.innerWidth - 10;
};

export const getSootnowenie = (image: ImageDto) => {
  const imageWidth = image.width / 2;
  if (window.innerWidth < imageWidth) {
    return window.innerWidth - 20;
  }
  return imageWidth - 20;
};

export const getPosition = (type: number, isNeedZoom: boolean) => {
  if (
    type === IMAGE_TYPE_MANY ||
    type === IMAGE_TYPE_ZOOM_WITH_BLACK ||
    type === IMAGE_TYPE_BASE_AND_SELECT_WITH_BLACK
  ) {
    return 'absolute';
  }
  if (type === IMAGE_TYPE_ZOOM && isNeedZoom) {
    return 'relative';
  }
  return undefined;
};

export const getMaxHeightImage2 = (imagesarrs: Image2Dto[]) => {
  let maxHeight = 0;
  for (let i = 0; i < imagesarrs.length; i += 1) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const imagarr = imagesarrs[i];
    if (imagesarrs[i].height > maxHeight) {
      maxHeight = imagesarrs[i].height;
    }
  }
  return maxHeight;
};

export const getMaxHeightToImage = (slides: LectionImageDto[]) => {
  let maxHeight = 0;
  for (let i = 0; i < slides.length; i += 1) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const imagarr = slides[i].images;
    for (let j = 0; j < slides[i].images.length; j += 1) {
      if (slides[i].images[j].height > maxHeight) {
        maxHeight = slides[i].images[j].height;
      }
    }
  }
  const newMaxHeight = maxHeight / 2;
  const inset = getInset();
  if ((window.innerHeight - inset) / 2 > newMaxHeight) {
    return (window.innerHeight - inset) / 2;
  }
  return newMaxHeight;
};

export const getWidthToImageOld = (image: ImageDto) => {
  const imageWidth = image.width / 2;
  if (window.innerWidth < imageWidth) {
    return window.innerWidth - 20;
  }
  return imageWidth;
};

export const getHeightToImageOld = (image: ImageDto) => {
  const inset = getInset();
  const imageHeight = image.height / 2;
  if ((window.innerHeight - inset) / 2 < imageHeight) {
    return (window.innerHeight - inset) / 2 - 10;
  }
  return imageHeight;
};

export const getMaxHeightConst = () => {
  const inset = getInset();
  const heigtWindow = window.innerHeight - inset;

  return heigtWindow / 2;
};

export const getMaxHeightConst2 = () => {
  const inset = getInset();
  const heigtWindow = window.innerHeight - inset - 10;
  return heigtWindow;
};

export const findCloud = (cloudDtos: CloudDto[], pageNum: string) => {
  let findId = false;
  for (let i = 0; i < cloudDtos.length; i += 1) {
    if (`page_${cloudDtos[i].page}` === pageNum) {
      findId = true;
    }
  }
  return findId;
};

export const calcWidth = (width: number, maxWidth: number) => {
  if (maxWidth < width) {
    return maxWidth - 20;
  }
  return width;
};

export const calcHeight = (height: number, maxHeight: number) => {
  const inset = getInset();
  if (maxHeight < height) {
    if (window.innerWidth > window.innerHeight - inset) {
      return getMaxHeightConst2() - 10;
    }
    return getMaxHeightConst() - 10;
  }
  return height;
};

export const getImageVideoSize = (
  image: Image2Dto,
  maxHeight: number,
  maxWidth: number,
  type?: number
) => {
  const resultArray: number[] = [];

  if (image.width === undefined || image.height === undefined) {
    resultArray[0] = window.innerWidth;
    resultArray[1] = 0;
    return resultArray;
  }

  if (type === IMAGE_TYPE_ZOOM || type === IMAGE_TYPE_ZOOM_WITH_BLACK) {
    resultArray[0] = image.width;
    resultArray[1] = image.height;
    return resultArray;
  }

  const sootNowenie: number[] = [2, 3, 4, 5, 6, 7, 8, 9, 10];

  for (let i = 0; i < sootNowenie.length; i += 1) {
    const realWidth = image.width / sootNowenie[i];
    const realHeight = image.height / sootNowenie[i];
    const realSootWToH = realWidth / realHeight;
    const realSootHToW = realHeight / realWidth;

    let width = calcWidth(realWidth, maxWidth);
    let height = calcHeight(realHeight, maxHeight);

    const isChangeHeight = height !== realHeight;
    const icChangeWidth = width !== realWidth;

    if (icChangeWidth && isChangeHeight) {
      resultArray[0] = width;
      resultArray[1] = height;
    } else {
      if (icChangeWidth) {
        height = realSootHToW * width;
      }
      if (isChangeHeight) {
        width = realSootWToH * height;
      }
      resultArray[0] = width;
      resultArray[1] = height;
      break;
    }
  }
  return resultArray;
};

export const getShortText = (test: string) => {
  let replacTextMore = test.replaceAll('\n', '</br>');
  replacTextMore = replacTextMore.replaceAll('</li><li>', '</br>');
  replacTextMore = replacTextMore.replaceAll(
    '<ul style="margin-top: 0px; margin-bottom: 0px">',
    ''
  );
  replacTextMore = replacTextMore.replaceAll(
    '<ul type="square" style="margin-top: 0px; margin-left: 40px; margin-bottom: 0px">',
    ''
  );
  replacTextMore = replacTextMore.replaceAll(
    '<ul type="circle" style="margin-top: 0px; margin-left: 20px; margin-bottom: 0px">',
    ''
  );
  replacTextMore = replacTextMore.replaceAll(
    '<ol style="margin-top: 0px; margin-bottom: 0px">',
    ''
  );
  replacTextMore = replacTextMore.replaceAll(
    '<ol type="a" style="margin-top: 0px; margin-left: 20px; margin-bottom: 0px">',
    ''
  );
  replacTextMore = replacTextMore.replaceAll(
    '<center><font style="font-weight: 600; font-size: 20px">',
    ''
  );
  replacTextMore = replacTextMore.replaceAll(
    '<div style="margin-top: 10px;"> </div>',
    ''
  );
  replacTextMore = replacTextMore.replaceAll('</font></center>', '');
  replacTextMore = replacTextMore.replaceAll('<center><b>', '');
  replacTextMore = replacTextMore.replaceAll('</b></center>', '');
  replacTextMore = replacTextMore.replaceAll('</ol>', '</br>');
  replacTextMore = replacTextMore.replaceAll('<li>', '');
  replacTextMore = replacTextMore.replaceAll('</li>', '');
  replacTextMore = replacTextMore.replaceAll('<b>', '');
  replacTextMore = replacTextMore.replaceAll('</b>', '');
  replacTextMore = replacTextMore.replaceAll('<i>', '');
  replacTextMore = replacTextMore.replaceAll('</i>', '');
  replacTextMore = replacTextMore.replaceAll(
    '<div style="background-color:#e0e0e0; border: 1px solid #e0e0e0; border-radius: 5px; padding: 5px; margin-top: 10px; margin-bottom: 10px "><font style="font-weight: 600">N/B:</font>',
    ''
  );
  replacTextMore = replacTextMore.replaceAll('</div>', '');
  replacTextMore = replacTextMore.replaceAll(
    '<ul style="margin-top: 0px; margin-bottom: 0px">',
    ''
  );
  replacTextMore = replacTextMore.replaceAll('</ul>', '');
  return `${replacTextMore.replaceAll('</br>', ' ').substring(0, 200)}...`;
};

export const getImgMarginLeft = () => {
  if (window.innerWidth > 450) {
    return (window.innerWidth - 450) / 2;
  }
  return '0px';
};

export const getButtonStackWidth = () => {
  if (window.innerWidth > 450) {
    return '450px';
  }
  return '100%';
};

export const getImgHeight = () => {
  if (window.innerWidth > 450) {
    return '300px';
  }
  return '182px';
};

export const getDefaultAlertProps = () => {
  const alertApp: IAlertProps = {
    message: '',
    severity: AlertSeverityEnum.error,
  };
  return alertApp;
};

export const getDefaultApiResult = () => {
  const apiResult: IApiResult = {
    isSuccess: false,
    status: -1,
    data: null,
    alert: getDefaultAlertProps(),
  };
  return apiResult;
};

export const setToken = (tokenType: string) =>
  `${localStorage.getItem(tokenType)}`;

export const getSimvol = (length: number) => {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const secureToken = () => {
  const expires = Math.floor(Date.now() / 1000) + 10;
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const md5 = require('md5');
  const crc = md5(`${SECRET_KEY_ADMIN}${expires}`);
  const url = `expires=${expires}&crc=${crc}`;
  return url;
};

export const secureContent = () => {
  const expires = Math.floor(Date.now() / 1000) + 10;
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const md5 = require('md5');
  const crc = md5(`${SECRET_KEY_CONTENT}${expires}`);
  const url = `expires=${expires}&crc=${crc}`;
  return url;
};

export const gteMd5 = (id: string) => {
  const timestamp = Math.floor(Date.now() / 1000);
  const toMd5 = `${timestamp}nurlat${id}`;
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const md5 = require('md5');
  const crc = `${timestamp}${md5(toMd5)}`;
  return crc;
};

export const gteMd5Conspect = (id: string) => {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const md5 = require('md5');
  const crc = `${md5(id)}`;
  return crc;
};

export const generateFilname = (name: string) => {
  const expires = Math.floor(Date.now() / 1000) + 10;
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const md5 = require('md5');
  const crc = md5(`${name}${expires}`);
  return `${crc}.png`;
};

export const formId = (text: string, page: string) => {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const md5 = require('md5');
  const crc = md5(`${text}${page}`);
  return crc;
};

export const getCookie = (name: string) => {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${name.replace(
        /([\\.$?*|{}\\(\\)\\[\]\\\\/\\+^])/g,
        '\\$1'
      )}=([^;]*)`
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const getKeyLevel = (key?: string) => {
  if (key === undefined) {
    return 0;
  }
  const arrayLevel = key.split('.');
  return arrayLevel.length;
};

export const getFontWeight = (level: number) => {
  switch (level) {
    case 1:
      return 900;
    case 2:
      return 700;
    case 3:
      return 500;
    case 4:
      return 300;
    case 5:
      return 100;
    default:
      return 100;
  }
};

export const getFontSize = (level: number) => {
  switch (level) {
    case 1:
      return '24px';
    case 2:
      return '20px';
    case 3:
      return '18px';
    case 4:
      return '16px';
    case 5:
      return '14px';
    default:
      return '14px';
  }
};

export const getPadding = (level: number) => {
  switch (level) {
    case 1:
      return '0px';
    case 2:
      return '25px';
    case 3:
      return '50px';
    case 4:
      return '75px';
    case 5:
      return '100px';
    default:
      return '0px';
  }
};
